import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";

export const container = css({
  display: "flex",
  flexDirection: "column",
});

export const heading = (theme: Theme) =>
  css({
    color: theme.disabled.text,
    fontWeight: typography.weightSemiBold,
    marginBottom: "1rem",
  });

export const link = (theme: Theme) =>
  css({
    color: theme.text.subdued,
    marginBottom: "1rem",
    display: "block",
    fontSize: typography.sizeSmall,
    lineHeight: typography.lineHeightXsmall,
    "&:hover": {
      color: theme.text.emphasis,
      textDecoration: "underline",
    },
  });

export const linkActive = (theme: Theme) =>
  css({
    color: theme.text.emphasis,
    fontWeight: typography.weightSemiBold,
  });

export const headingWrapper = css({
  padding: "0 1rem",
});

export const headingChildWrapper = css({
  paddingLeft: "2rem",
});

export const relatedTopics = (theme: Theme) =>
  css({
    padding: "1rem",
    backgroundColor: theme.system.backgroundMuted,
    borderRadius: "0.5rem",
  });

export const gap = css({
  marginTop: "0.5rem",
});

export const relatedTopicsList = css({
  listStyle: "disc",
  paddingLeft: "1.5rem",
});

export const relatedTopicLink = (theme: Theme) =>
  css({
    "&:hover": {
      textDecoration: "underline",
      color: theme.text.emphasis,
    },
  });
